<div class="modal-header">
  <img src="assets/images/lg_ke2.png" style="width: 250px; margin-right:20px;" />

  <div class="title-wrap">
    <h6 class="m-0 text-right">{{ title }}</h6>
    <button
      mat-button
      aria-label="Close"
      (click)="onCloseClick()"
      style="min-width: 0px; padding: 0 !important"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
